<template>
  <div class="user">
    <div class="pb50">
      <!--内容-->
      <div class="product-content" v-if="detail.profits">
        <!--基本信息-->
        <div class="common-form">基本信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">总收益：</span>
                {{ detail.productprofits.total_profits }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">已释放收益：</span>
                {{ detail.productprofits.resolve_profits }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">结算方式：</span>
                <span  v-if="detail.productprofits.cal_type == 0">本息同返</span>
                <span v-if="detail.productprofits.cal_type == 1">先息后本</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">产生时间：</span>
                {{ detail.productprofits.create_time }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="nickName" label="会员">
               <template slot-scope="scope">
                <div class="d-s-c">
                  <img v-img-url="scope.row.user.avatarUrl" width="60px" height="60px" />
                  <div class="ml10">
                    <p class="f14 fb">{{ scope.row.user.nickName }}</p>
                    <p class="gray3" v-if="scope.row.user.mobile">手机：{{ scope.row.user.mobile }}</p>
                    <p class="gray9">用户ID：{{ scope.row.user.user_id }}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="total_profits" label="每期收益"></el-table-column>
            <el-table-column prop="resolve_profits" label="已释放收益"></el-table-column>
            <el-table-column prop="profits" label="剩余收益"></el-table-column>
            <el-table-column prop="begin_time" label="开始日期"></el-table-column>
            <el-table-column prop="end_time" label="结束日期"></el-table-column>
            <el-table-column prop="periods" label="期数">
              <template slot-scope="scope">
                  <div class="d-s-c">第 {{scope.row.periods}} 期</div>
              </template>
            </el-table-column>
            <el-table-column prop="is_settled" label="状态">
              <template slot-scope="scope">
                  <div class="d-s-c" v-if="scope.row.is_settled==0">进行中</div>
                  <div class="d-s-c" v-if="scope.row.is_settled==1">已结束</div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" ></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
      <!--操作-->
      <div class="common-button-wrapper">
        <el-button size="small" @click="cancelFunc">返回</el-button>
      
      </div>
    </div>
  </div>
</template>

<script>
  import ProductProfitsApi from '@/api/productprofits.js';
  export default {
    components: {},
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        formInline: {
          id: 0,
          keyword: ''
        },
        detail: [],
        status: ['未开始', '进行中', '已结束'],
        file:{},
      };
    },
    created() {
      this.formInline.profits_id = this.$route.query.profits_id;
     
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        ProductProfitsApi.getDetail(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            if(data.data.list.data){
              self.detail = data.data.list.data[0]
            }
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {
              self.loading = false;
          });
      },

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/productprofits/profits/detail.vue